import { useUrlFilters } from "./url-filters.js";

/**
 * The date range and engine a report view reads, from the address.
 *
 * Overview, Prompts, Citations and Where to publish each computed this for
 * themselves, four identical copies of "28 days back unless the URL says
 * otherwise". Now the top bar draws the filters and the screen reads the
 * numbers, so the two have to agree exactly, and one function is the only way
 * they cannot drift apart.
 */

/** Days back, as a default. The URL wins whenever it says otherwise. */
export const DEFAULT_RANGE_DAYS = 28;

const DAY_MS = 24 * 60 * 60 * 1000;

/** A calendar day in UTC, the form every range parameter is written in. */
export function isoDay(date: Date): string {
  return date.toISOString().slice(0, 10);
}

export interface ReportRange {
  readonly from: string;
  readonly to: string;
  /** Today, as a day: the latest the date picker lets a reader choose. */
  readonly today: string;
  /** Null, not "all": the filter being off is the absence of the parameter. */
  readonly engine: string | null;
}

/** `today` is injected so the range is a value rather than a read of the clock. */
export function useReportRange(today: Date): ReportRange {
  const { params } = useUrlFilters();
  return {
    to: params.get("to") ?? isoDay(today),
    from:
      params.get("from") ??
      isoDay(new Date(today.getTime() - DEFAULT_RANGE_DAYS * DAY_MS)),
    today: isoDay(today),
    engine: params.get("engine"),
  };
}
